export function appRun(Restangular, $location, $injector, $rootScope, $timeout) {
  "ngInject";

  let stateChangeWatch = function () {
    let state = $injector.get('$state');
    return $rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams, error) {
      if (error[0] === "authError") {
        return state.go(error[1]);
      }
    });
  };

  $timeout(stateChangeWatch, 500);
}
